import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, Paper, TextField, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import axios from "axios";
import * as React from "react";
import * as weightedRandom from "weighted-random";

import { LoadingWrapper } from "../../components/LoadingWrapper";
import { getItemParam, Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

import { ChestData } from ".";
import { InventoryIcon } from "../../components/InventoryIcon";
import {Config} from "../../config/config";

interface NewBundleSate {
    modalVisible: boolean;
    rangeValue: number;
    loaded: boolean;
    chestConfig: any;
    outcome: any;
}

interface NewBundleProps {
    chest: ChestData;
    classes: any;
    closeRowMenu(): void;
}

class SimulateChestWrapped extends React.Component<NewBundleProps, NewBundleSate> {

    constructor(props) {
        super(props);
        // List with grid items
        this.state = {
            modalVisible: false,
            loaded: false,
            chestConfig: null,
            // Form data
            rangeValue: 1,
            outcome: null,
        };
    }

    simulate = () => {
        this.setState({ outcome: null }, () => {
            const level = this.state.rangeValue;
            const range = { ...this.state.chestConfig.data.find(data => data.range.start <= level && data.range.end >= level) };

            if (!range) {
                PopupMessage.error("Something went wrong");
                return;
            }

            const randomItems = range.slots.map(this.randomizeSlot);
            const itemsWithNames = randomItems.map(item => ({
                ...item,
                itemName: getItemParam(item.itemId, "name"),
                type: getItemParam(item.itemId, "type"),
            }));

            this.setState({ outcome: itemsWithNames });
        });
    }

    randomizeSlot = (slot) => {
        const weights = slot.map(item => item.weight);
        const selectionIndex = weightedRandom(weights);
        return slot[selectionIndex];
    }

    showModal = () => this.setState({ modalVisible: true }, () => {
        this.fetchChestConfig();
    })

    handleModalCancel = () => {
        this.props.closeRowMenu();
        this.setState({ modalVisible: false });
    }
    fetchChestConfig = async () => {
        if (!this.props.chest) {
            return;
        }

        try {
            // Put data to S3
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/chest/${this.props.chest.chest_id}`, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            this.setState({ chestConfig: response.data.data, loaded: true });
        } catch (error) {
            this.setState({ loaded: true });

            PopupMessage.error("Couldn't fetch chest configuration");
        }
    }

    changeRangeValue = _name => event => this.setState({ rangeValue: event.target.value });

    getDialogContent = () => {
        if (!this.state.loaded) {
            return <div style={{ height: 100 }}></div>;
        }

        return <div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <TextField
                    margin="normal"
                    id="hq_level"
                    label="Headquarters Level"
                    onChange={this.changeRangeValue("rangeValue")}
                    value={this.state.rangeValue}
                    type="number"
                    size="small"
                    style={{ display: "inline-block" }}
                />

                <Button
                    disableElevation
                    color="primary"
                    variant="contained"
                    size="small"
                    onClick={this.simulate}
                    style={{ display: "inline-block", marginLeft: 15, marginTop: 5 }}
                >
                    Simulate
                </Button>
            </div>

            {this.state.outcome && <Grid container spacing={2} style={{ marginTop: 10 }}>
                {[...this.state.outcome].map((item, index) => (
                    <Grid item sm={3} key={item.itemId + index}>
                        <Box style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                            <div>
                                {InventoryIcon({
                                    itemId: item.itemId,
                                    style: { maxWidth: 100 },
                                    amount: item.amount,
                                })}
                            </div>
                            <div style={{ marginTop: 10, textAlign: "center" }}>
                                {Helpers.getLocalizationName(item.itemName)}
                            </div>
                        </Box>

                    </Grid>
                ))}
            </Grid>}
        </div>;
    }

    render() {
        return (
            <div>
                <MenuItem onClick={this.showModal}>
                    Simulate
                </MenuItem>

                <Dialog
                    open={this.state.modalVisible}
                    onClose={this.handleModalCancel}
                    aria-labelledby="form-dialog-title"
                    fullWidth={true}
                    maxWidth="md"
                >
                    <DialogTitle id="form-dialog-title">
                        Simulate chest drops
                    </DialogTitle>
                    <DialogContent>
                        <LoadingWrapper loading={!this.state.loaded}>
                            {this.getDialogContent()}
                        </LoadingWrapper>
                    </DialogContent>
                    <DialogActions>
                        <Button disableElevation onClick={this.handleModalCancel} variant="contained" size="small">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

const styles: any = theme => ({
    wrapper: {
        margin: 8,
        position: "relative",
    },
});

export const SimulateChest = withStyles(styles)(SimulateChestWrapped);
